// import React, {useContext, useEffect, useState} from 'react'
import React, {useEffect, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
// import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
// import { useHistory } from 'react-router-dom';
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";


const MaritalStatusStep = ({_step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext, getStep}) => {
    const lang = localStorage.getItem('language')
    const data = getDataFromContext(step_ID)

    const options = [
        {value:1, label:t('personal_infos.Personal_info_civil_state.married')},
        {value:2, label:t('personal_infos.Personal_info_civil_state.single')},
        {value:3, label:t('personal_infos.Personal_info_civil_state.widower')},
        {value:4, label:t('personal_infos.Personal_info_civil_state.divorced')},
        {value:5, label:t('personal_infos.Personal_info_civil_state.defacto_separated')},
        {value:6, label:t('personal_infos.Personal_info_civil_state.separated')},
        {value:7, label:t('personal_infos.Personal_info_civil_state.legal_cohabitee')},
    ]

    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [nextTick, setNextTick] = useState(false)
    const [savedData, setSavedData] = useState({})

    const getInputValue = (name, value) => {
        if (value !== "") {
            setInputData({
                ...inputData,
                [name] : value
            })
        }
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step:`summary`})
        // _step_service({step_ID, setIsLoading, next_step:`/${lang.toLowerCase()}/intro-legal`})
    }

    useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            setDataToContext(step_ID, step_URL, step_ID, inputData[step_ID])
            setNextTick(true)
        }
    }, [inputData])

        useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            action()
        }
        }, [nextTick])
    
    
    useEffect(() => {
        getStep(["internal_nationality_country"]).then(res => {
            res["internal_nationality_country"] !== "null" && setDataToContext("nationality", "", "internal_nationality_country", JSON.parse(res["internal_nationality_country"]));
        })
        const asyncfunc = async () => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        stepSeq: "1",
                        stepName: "personal info:civil status",
                        flowType: "sales",
                        flowName: "onboarding",
                        productName: "onboarding",
                        trackMethod: "flow"
                    }
                );
            }
            const serverData = await getStep(['civil_state'])
            setSavedData({civil_state: Number(serverData.civil_state)})
        }
        asyncfunc()
     }, [])


    
    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{t('personal_infos.Personal_info_civil_state.title')}</h3>
                </BaseParagraph>

                 <InputField type={"select"} name={"civil_state"}
                    options={options}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && savedData[step_ID]}

                />
            </StepsLoader>


        </>
    )
}

MaritalStatusStep.propTypes = {
    name: PropTypes.string
}

MaritalStatusStep.defaultProps = {
    name: "email-step"
}


export default MaritalStatusStep